<template>
    <div class="aboutus">
        <div class="aboutus_description">
            <span class="title">About <span class="us">us</span></span>
            <p>
                Our dedicated travel specialists work directly with all the major airlines to
                <strong>secure</strong> discounts on first and business class seats.
            </p>
            <p>
                We ensure the greatest possible <strong>value</strong> for your travel by negotiating lower prices on
                available seats and matching those seats to your schedule and budget.
            </p>
            <!--<button class="btn">Call back</button>-->
        </div>
        <div class="aboutus_images">
            <img src="../../../assets/svgs/Group 7947.svg" class="second_image" />
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'AboutUs',
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

.aboutus {
    width: 100%;
    padding: 50px 0 50px 0;
    color: $mainTextBlueColor;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1250px;
    margin: auto;

    .aboutus_description {
        font-family: 'Gilroy-Bold', sans-serif;
        letter-spacing: 0;
        text-align: left;
        width: 40%;

        .title {
            font-size: 36px;
            line-height: 43px;
        }

        .us {
            display: none;
        }

        p {
            font-family: 'Gilroy-Light', sans-serif;
            font-size: 20px;
            line-height: 24px;

            strong {
                font-family: 'Gilroy-Bold', sans-serif;
            }
        }

        .btn {
            border: 1px solid var(--unnamed-color-000052);
            border: 1px solid $mainTextBlueColor;
            background: none;
            background-color: transparent;
            font-family: 'Gilroy-Bold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            color: $mainTextBlueColor;
        }
    }

    .aboutus_images {
        width: 582px;
        height: 494px;
        background: url('../../../assets/images/about/pexels-fauxels-3183197.png');
        background-position: center;
        border-radius: 30px 0 0 30px;
        position: relative;

        @media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min--moz-device-pixel-ratio: 2) {
            background-image: url('../../../assets/images/about/pexels-fauxels-3183197@2x.png');
        }

        img {
            position: absolute;
            left: -60px;
            bottom: -60px;
        }
    }

    @media (max-width: 1200px) {
        padding-left: 60px;

        .aboutus_images {
            width: 482px;
            height: 394px;
            background-size: 482px 394px;
        }
    }

    @media (max-width: 992px) {
        .aboutus_images {
            width: 432px;
            height: 354px;
            background-size: 432px 354px;
        }
    }

    @media (max-width: 768px) {
        flex-direction: column-reverse;
        padding-left: 0;

        .aboutus_description {
            width: 100%;
            padding: 50px 50px 0 50px;
            display: flex;
            flex-direction: column;

            .title {
                font-size: 28px;
                line-height: 34px;
                align-self: center;
            }

            .us {
                display: inline;
                font-size: 28px;
                line-height: 34px;
            }

            p {
                font-size: 18px;
                line-height: 22px;
            }

            .btn {
                font-size: 18px;
                line-height: 22px;
                align-self: center;
            }
        }

        .aboutus_images {
            width: 375px;
            height: 251px;
            background-size: 375px 251px;
            border-radius: 0;

            img {
                display: none;
            }
        }
    }

    @media (max-width: 350px) {
        .aboutus_images {
            width: 320px;
            height: 214px;
            background-size: 320px 214px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/AboutUs.vue